import { useState } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import type { AssistantCaseCard as CaseCardData } from '../contract'
import AssistantCaseCard from './AssistantCaseCard'

/** Cards shown before "Show more", so a long list doesn't bury the answer. */
export const ASSISTANT_LIST_PREVIEW_COUNT = 3

interface AssistantCaseListProps {
  cases: CaseCardData[]
  heading?: string
  /** Shown when there are no cases, e.g. "Nothing needs you right now." */
  emptyText?: string
}

const AssistantCaseList = ({
  cases,
  heading,
  emptyText,
}: AssistantCaseListProps) => {
  const [expanded, setExpanded] = useState(false)
  const hidden = cases.length - ASSISTANT_LIST_PREVIEW_COUNT
  const visible =
    expanded || hidden <= 0
      ? cases
      : cases.slice(0, ASSISTANT_LIST_PREVIEW_COUNT)

  if (cases.length === 0 && !emptyText) return null

  return (
    <Box
      data-testid="assistant-case-list"
      sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}
    >
      {heading && (
        <Typography variant="overline" color="text.secondary" lineHeight={1.5}>
          {heading}
        </Typography>
      )}
      {cases.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          {emptyText}
        </Typography>
      ) : (
        visible.map(item => <AssistantCaseCard key={item.caseId} data={item} />)
      )}
      {hidden > 0 && (
        <Button
          size="small"
          onClick={() => setExpanded(value => !value)}
          sx={{ alignSelf: 'flex-start' }}
        >
          {expanded ? 'Show fewer' : `Show ${hidden} more`}
        </Button>
      )}
    </Box>
  )
}

export default AssistantCaseList
